import { IconContext } from '@phosphor-icons/react';
import type { ReactNode } from 'react';

const iconDefaults = {
  weight: 'regular',
  size: '1em',
  color: 'currentColor',
} as const;

export function IconProvider({ children }: { children: ReactNode }) {
  return <IconContext.Provider value={iconDefaults}>{children}</IconContext.Provider>;
}
